import React from 'react';
export function Process() {
  const steps = [{
    number: '01',
    title: 'Discovery & Analysis',
    description: 'We start by understanding your business, goals, target audience, and current lead generation efforts to identify opportunities.'
  }, {
    number: '02',
    title: 'Strategy Development',
    description: 'Our team creates a customized lead generation strategy tailored to your specific business needs and market position.'
  }, {
    number: '03',
    title: 'Implementation',
    description: 'We deploy the strategy across multiple channels, setting up campaigns, content, and tracking systems.'
  }, {
    number: '04',
    title: 'Lead Nurturing',
    description: 'Qualified leads are nurtured through personalized follow-up sequences to move them through your sales funnel.'
  }, {
    number: '05',
    title: 'Optimization & Scaling',
    description: 'We continuously analyze performance data, optimize campaigns, and scale what works to maximize your ROI.'
  }, {
    number: '06',
    title: 'Reporting & Insights',
    description: 'Regular reporting keeps you informed of progress, results, and insights to guide future strategy decisions.'
  }];
  return <section id="process" className="py-28 bg-white relative" data-id="element-226">
      {/* Decorative elements */}
      <div className="absolute top-40 left-0 w-72 h-72 bg-amber-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-227"></div>
      <div className="absolute bottom-40 right-0 w-96 h-96 bg-red-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-228"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        <div className="text-center mb-20" data-id="element-230">
          <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-100 rounded-full mb-4" data-id="element-231">
            Our Process
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-232">
            How We Generate Leads That Convert
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-233">
            Our proven 6-step process ensures consistent results and continuous
            improvement for your lead generation campaigns.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-234">
          {steps.map((step, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 relative overflow-hidden group hover:border-amber-100 hover:translate-y-[-5px]" data-id="element-235">
              <div className="absolute -top-10 -left-10 text-[140px] font-bold text-gray-50 select-none group-hover:text-amber-50 transition-colors" data-id="element-236">
                {step.number}
              </div>
              <div className="relative" data-id="element-237">
                <div className="w-16 h-1.5 bg-gradient-to-r from-amber-400 to-red-400 rounded-full mb-6" data-id="element-238"></div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-239">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-240">{step.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-24 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-xl p-12 text-center relative overflow-hidden" data-id="element-241">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-242">
            <div className="absolute top-10 left-10 w-40 h-40 bg-amber-400/10 rounded-full blur-3xl" data-id="element-243"></div>
            <div className="absolute bottom-10 right-10 w-60 h-60 bg-red-400/10 rounded-full blur-3xl" data-id="element-244"></div>
          </div>
          <div className="relative z-10" data-id="element-245">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-246">
              Ready to Transform Your Lead Generation?
            </h3>
            <p className="text-gray-300 mb-10 max-w-2xl mx-auto text-lg" data-id="element-247">
              Schedule a free consultation with our experts to discuss how our
              process can be tailored to your business needs.
            </p>
            <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-lg shadow-lg text-gray-900 bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 transition-all duration-300 hover:shadow-amber-500/20" data-id="element-248">
              Schedule Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>;
}